
<script>
    import {USER} from '../store.js'
    import {onMount} from 'svelte'
    import {API,http_headers} from '../global.js'
    export let data={}

    let errores = {'anticipo':'', 'saldo':''}
    let loading = false
    let ejecutivos = []

    const calcularSaldo = () => {
        data.cuotasAnticipo = []
        data.cuotasSaldo = []
        data.importeVenta = parseFloat(data.importeVenta||0)*1.00
        data.importeAnticipo = parseFloat(data.importeAnticipo||0)*1.00
        data.importeSaldo = data.importeVenta-data.importeAnticipo
        data.importeComisionable = (parseFloat(data.importeComisionable||0)<0.1?data.importeVenta:data.importeComisionable)*1.00
        if(data.importeComisionable>data.importeVenta) data.importeComisionable = data.importeVenta
        if(data.importeSaldo<0){
            data.importeSaldo = 0
            errores.saldo = 'Revise los importes ingresados'
        }else{
            errores.saldo = ''
        }
        if(data.importeAnticipo>0&&data.cantCuotasAnticipo>0){
            calcularCuotasAnticipo()
        }else{
            data.cuotasAnticipo = []    
        }
        if(data.importeSaldo>0&&data.cantCuotasSaldo>0){
            calcularCuotasSaldo()
        }else{
            data.cuotasSaldo = []
        }
    }

    const calcularCuotasAnticipo = () => {
        data.cuotasAnticipo = []
        if(data.cantCuotasAnticipo<1){
            data.importeAnticipo = 0.00
        }
        let importe = Math.floor(data.importeAnticipo/data.cantCuotasAnticipo).toFixed(2)
        
        for(let i=0; i<data.cantCuotasAnticipo; i++){
            let cuota = 'A'+('000'+(i+1).toString()).substr(-3)
            let fecha =  (new Date).toISOString().substr(0,10)
            data.cuotasAnticipo = [...data.cuotasAnticipo,{ cuota, fecha, importe }]
        }
        calcularFechasAnticipo()
        calcularUltCuotaAnticipo()
    }

    const calcularCuotasSaldo = () => {
        data.cuotasSaldo = []
        if(data.cantCuotasSaldo<1){
            alert("No es posible colocar en 0 las cuotas del saldo")
            data.cantCuotasSaldo = 1
        }
        let importe = Math.floor(data.importeSaldo/data.cantCuotasSaldo).toFixed(2)
        
        for(let i=0; i<data.cantCuotasSaldo; i++){
            let cuota = 'S'+('000'+(i+1).toString()).substr(-3)
            let fecha =  (new Date).toISOString().substr(0,10)
            data.cuotasSaldo = [...data.cuotasSaldo,{ cuota, fecha, importe }]
        }
        calcularFechasSaldo()
        calcularUltCuotaSaldo()
    }


    const calcularUltCuotaAnticipo = () => {
        let suma = 0
        for(let i=0;i<data.cantCuotasAnticipo-1;i++){
            suma = suma + parseFloat(data.cuotasAnticipo[i].importe)
        }
        if((data.importeAnticipo - suma)>0){
            data.cuotasAnticipo[data.cantCuotasAnticipo-1].importe =  (data.importeAnticipo - suma).toFixed(2)
            errores['anticipo'] = ''
        }else{
            data.cuotasAnticipo[data.cantCuotasAnticipo-1].importe = 0
            errores['anticipo'] = 'Revise importes de anticipo'
        }
    }

    const calcularUltCuotaSaldo = () => {
        let suma = 0
        for(let i=0;i<data.cantCuotasSaldo-1;i++){
            suma = suma + parseFloat(data.cuotasSaldo[i].importe)
        }
        if((data.importeSaldo - suma)>0){
            data.cuotasSaldo[data.cantCuotasSaldo-1].importe =  (data.importeSaldo - suma).toFixed(2)
            errores['saldo'] = ''
        }else{
            data.cuotasSaldo[data.cantCuotasSaldo-1].importe = 0
            errores['saldo'] = 'Revise importes de Saldo'
        }
    }

    const calcularFechasAnticipo = () => {
        let date = new Date()
        for(let i=0; i<data.cantCuotasAnticipo; i++){
            data.cuotasAnticipo[i].fecha = (new Date(date.getFullYear(),date.getMonth()+1+i,1)).toISOString().substr(0,10)
        }
    }

    const calcularFechasSaldo = () => {
        let date = new Date()
        for(let i=0; i<data.cantCuotasSaldo; i++){
            data.cuotasSaldo[i].fecha = (new Date(date.getFullYear(),date.getMonth()+1+i+parseInt(data.cantCuotasAnticipo),1)).toISOString().substr(0,10)
        }
    }

    const reordenarFechasAnticipo = (idx) => {
        let fecha = data.cuotasAnticipo[idx].fecha.split('-')
        let date = new Date(fecha[0],fecha[1],1)
        for(let i=idx+1; i<data.cantCuotasAnticipo; i++){
            data.cuotasAnticipo[i].fecha = (new Date(date.getFullYear(),date.getMonth()+i-idx-1,1)).toISOString().substr(0,10)
        }
    }

    const reordenarFechasSaldo = (idx) => {
        let fecha = data.cuotasSaldo[idx].fecha.split('-')
        let date = new Date(fecha[0],fecha[1],1)
        for(let i=idx+1; i<data.cantCuotasSaldo; i++){
            data.cuotasSaldo[i].fecha = (new Date(date.getFullYear(),date.getMonth()+i-idx-1,1)).toISOString().substr(0,10)
        }
    }

    onMount( async() => {
        loading = true
        let rs = await fetch(`${API}/usuarios?rpp=9999&activo=1`)
        let ds = await rs.json()
        ejecutivos = ds.data
        //console.log(ejecutivos)
        loading = false
    })


</script>

<div class="mb-3 row border-bottom pb-2">

    <label for="" class="col-2 col-form-label">Linea de Venta</label>
    <div class="col-5">
        <span class="label">Vendedor</span>
        <select class="form-select form-select-sm" bind:value={data.vendedor}>
            <!--option value="{$USER.username}">{$USER.username}</option-->
            {#each ejecutivos as ejec, index}
                <option value="{ejec.username}">{ejec.username}</option>
            {/each}
        </select>
    </div>
    <div class="col-5">
        <span class="label">Linea1</span>
        <select class="form-select form-select-sm" bind:value={data.linea1}>
            <option value="{''}"></option>
            {#each ejecutivos as ejec, index}
                <option value="{ejec.username}">{ejec.username}</option>
            {/each}
        </select>
    </div>
    <div class="col-5 offset-2">
        <span class="label">Linea2</span>
        <select class="form-select form-select-sm" bind:value={data.linea2}>
            <option value="{''}"></option>
            {#each ejecutivos as ejec, index}
                <option value="{ejec.username}">{ejec.username}</option>
            {/each}
        </select>
    </div>
    <div class="col-5">
        <span class="label">Linea3</span>
        <select class="form-select form-select-sm" bind:value={data.linea3}>
            <option value="{''}"></option>
            {#each ejecutivos as ejec, index}
                <option value="{ejec.username}">{ejec.username}</option>
            {/each}
        </select>
    </div>
</div>
<div class="mb-2 row">
    <label for="" class="col-sm-2 col-form-label">MONEDA</label>
    <div class="col-sm-4">
        <select bind:value={data.moneda}>
            <option value="$">Pesos AR [$AR]</option>
            <option value="U$s">Dolares [$Us]</option>
            <option value="U$r" >Pesos UR [$UR]</option>
        </select>
    </div>
    <label for="" class="col-sm-2 col-form-label">Complejo</label>
    <div class="col-sm-4">
        <select bind:value={data.complejo}>
            <option value="RDA">RDA</option>
            <option value="RDE">RDE</option>
            <option value="OTRO">OTRO</option>
        </select>
    </div>
</div>
<div class="mb-2 row">
    <label for="" class="col-sm-2 col-form-label">Importe Venta</label>
    <div class="col-sm-4">
        <input type="text" class="form-control" bind:value={data.importeVenta} on:change={calcularSaldo}>
    </div>
    <label for="" class="col-sm-2 col-form-label">Importe Comisionable</label>
    <div class="col-sm-4">
        <input type="text" class="form-control" bind:value={data.importeComisionable} >
    </div>
</div>

<div class="mb-2 row">
    <label for="" class="col-sm-2 col-form-label">Importe Anticipo</label>
    <div class="col-sm-4">
        <input type="text" class="form-control" bind:value={data.importeAnticipo} on:change={calcularSaldo}>
    </div>
    <label for="" class="col-sm-2 col-form-label">Cuotas Anticipo</label>
    <div class="col-sm-1">
        <input type="text" class="form-control" bind:value={data.cantCuotasAnticipo} on:change={calcularCuotasAnticipo}>
    </div>
</div>

<details class="mx-4 pb-4">
    <summary class="m-2 p-2" >ANTICIPO : detalles</summary>
    {#each data.cuotasAnticipo as ca,index}
        <div class="input-group my-2 px-4">
            <input class="form-control ps-3" value={data.cuotasAnticipo[index].cuota} readonly tabindex="-1">
            <input class="form-control text-center" bind:value={data.cuotasAnticipo[index].fecha} on:change={()=>reordenarFechasAnticipo(index)} >  
            <input class="form-control text-end {errores.anticipo!==''?'border-danger':''}" bind:value={data.cuotasAnticipo[index].importe} on:change={calcularUltCuotaAnticipo}>  
        </div>
    {:else}
        <p>Revise pago de anticipo.</p>
    {/each}
</details>

<div class="mb-2 row">
    <label for="" class="col-sm-2 col-form-label">Importe Saldo</label>
    <div class="col-sm-4">
        <input type="text" class="form-control {errores.saldo!==''?'border-danger':''}" bind:value={data.importeSaldo} readonly>
    </div>
    <label for="" class="col-sm-2 col-form-label">Cuotas Saldo</label>
    <div class="col-sm-1">
        <input type="text" class="form-control" bind:value={data.cantCuotasSaldo} on:change={calcularCuotasSaldo}>
    </div>
</div>

<details class="mx-4 pb-4">
    <summary class="m-2 p-2" >SALDO : detalles</summary>
    {#each data.cuotasSaldo as ca,index}
        <div class="input-group my-2 px-4">
            <input class="form-control ps-3" value={data.cuotasSaldo[index].cuota} readonly tabindex="-1">
            <input class="form-control text-center" bind:value={data.cuotasSaldo[index].fecha} on:change={()=>reordenarFechasSaldo(index)} >  
            <input class="form-control text-end {errores.saldo!==''?'border-danger':''}" bind:value={data.cuotasSaldo[index].importe} on:change={calcularUltCuotaSaldo}>  
        </div>
    {:else}
        <p>Revise pago de Saldo.</p>
    {/each}
</details>


<style>
    .label{
        font-size: 0.6rem;
        color: #888;
        display: block;
        padding-left: 6px;
        padding-top: 2px;
    }
</style>